import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHandDrop = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.14575 13.4583V20.9583"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6458 19.7083C16.6458 19.0453 16.3824 18.4094 15.9135 17.9406C15.4447 17.4717 14.8088 17.2083 14.1458 17.2083H11.0208C11.0208 16.5453 10.7574 15.9094 10.2885 15.4406C9.81968 14.9717 9.18379 14.7083 8.52075 14.7083H4.14575V19.7083H16.6458Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.52075 17.2083H11.0208"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7708 9.70833C19.7708 10.7029 19.3757 11.6567 18.6724 12.36C17.9691 13.0632 17.0153 13.4583 16.0208 13.4583C15.0262 13.4583 14.0724 13.0632 13.3691 12.36C12.6658 11.6567 12.2708 10.7029 12.2708 9.70833C12.2708 7.20833 15.3958 2.83333 16.0208 2.83333C16.6458 2.83333 19.7708 7.20833 19.7708 9.70833Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0208 10.9583C15.6892 10.9583 15.3713 10.8266 15.1369 10.5922C14.9024 10.3578 14.7708 10.0399 14.7708 9.70833"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHandDrop.displayName = 'SvgHandDrop';
export default SvgHandDrop;
